'use strict';
import React from 'react';

/**
 * Input validation component.
 * Input fields can include errors. Can be rendered both with and without label.
 *
 * Usage:
 *
 * ```Javascript
 * <InputLabel label="name" for="model-name">
 *   <InputValidation>{model.errors.name}</InputValidation>
 *   <InputField name="name" id="model-name" error/>
 * </InputLabel>
 * ```
 *
 * @extends {React.Component}
 */
class InputValidation extends React.Component {

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, ...otherProps } = this.props;
    return (
      <div {...otherProps} className="InputField-error">{children}</div>
    );
  }
}

export default InputValidation;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/inputField/inputValidation.jsx